import { render, staticRenderFns } from "./Productores.vue?vue&type=template&id=4218d8f5&"
import script from "./Productores.vue?vue&type=script&lang=js&"
export * from "./Productores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports